<ng-container *ngIf="accommodationState === 'hotel'; else ecolodge">
      <iho-hotel-info />
</ng-container>

<ng-template #ecolodge>
      <iho-ecolodge-info />
</ng-template>